import { Link } from "react-router-dom"
import logo from "../../assets/footer-frog.png"
import { useState, useEffect } from "react"
import BottomBar from "@/components/sidebar/BottomBar"
import { useSelector } from "react-redux"
import axios from "axios"

const BulkEmail = () => {
    const { playing } = useSelector(state => state.music)
    const [activeTab, setActiveTab] = useState("bulkEmail")
    const [emails, setEmails] = useState("")
    const [urls, setUrls] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [emailSubject, setEmailSubject] = useState("Check out Sound of Meme!")
    const [emailMessage, setEmailMessage] = useState("Hello! I wanted to share this amazing meme with you. Check it out at the link below:")
    const [emailFrom, setEmailFrom] = useState("soundofmeme@soundofmeme.com")

    const [reviews, setReviews] = useState([])
    const [reviewsLoading, setReviewsLoading] = useState(false)
    const [reviewsError, setReviewsError] = useState(null)
    const [pagination, setPagination] = useState({
        page: 1,
        page_size: 10,
        total_records: 0,
        total_pages: 0
    })

    const [selectedStatus, setSelectedStatus] = useState("pending")

    const fetchReviews = async (page = 1) => {
        setReviewsLoading(true)
        setReviewsError(null)

        try {
            const token = localStorage.getItem('token')
            const response = await axios.get(
                `https://testapi.soundofmeme.com/admin/reviews?status=${selectedStatus}&page=${page}&page_size=10`,
                {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            )

            setReviews(response.data.reviews)
            setPagination(response.data.pagination)
        } catch (err) {
            setReviewsError(err.response?.data?.message || err.message || 'Failed to fetch reviews')
        } finally {
            setReviewsLoading(false)
        }
    }

    useEffect(() => {
        if (activeTab === "reviews") {
            fetchReviews()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, selectedStatus])

    const generateUrls = async () => {
        if (!emails.trim()) {
            setError("Please enter at least one email address")
            return
        }

        setLoading(true)
        setError(null)

        try {
            const response = await axios.get(
                `https://testapi.soundofmeme.com/reviews/bulk-url?emails=${encodeURIComponent(emails)}`,
                { headers: { 'accept': 'application/json' } }
            )

            const emailList = emails.split(',').map(email => email.trim()).filter(email => email);
            const urlResponses = Array.isArray(response.data) ? response.data : [response.data];

            const mappedResults = urlResponses.map((url, index) => ({
                email: emailList[index] || 'Unknown',
                url: url,
                gmailLink: `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(emailList[index])}&su=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailMessage + '\n\n' + url)}`
            }));

            setUrls(mappedResults);
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'Failed to generate URLs')
        } finally {
            setLoading(false)
        }
    }

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                // You could add a toast notification here
            })
            .catch(err => {
                console.error('Failed to copy: ', err)
            })
    }

    const renderPagination = () => {
        const pages = []
        for (let i = 1; i <= pagination.total_pages; i++) {
            pages.push(
                <button
                    key={i}
                    onClick={() => fetchReviews(i)}
                    className={`px-3 py-1 mx-1 rounded ${pagination.page === i ?
                        'bg-green-500 dark:bg-pink-500 text-white' :
                        'bg-slate-700 dark:bg-pink-300 text-slate-200 dark:text-slate-700'}`}
                >
                    {i}
                </button>
            )
        }
        return (
            <div className="flex justify-center mt-4">
                {pages}
            </div>
        )
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString)
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
    }

    return (
        <div className="z-[9999] bg-gradient-to-br from-slate-950 to-slate-800 dark:from-pink-200 dark:via-pink-300 dark:to-pink-200 text-slate-300 dark:text-slate-700 min-h-screen font-sans">
            <div className="fixed top-0 left-0 w-full bg-slate-950 dark:bg-pink-200 h-16 border-b border-slate-800 dark:border-pink-700">
                <div className="mx-auto max-w-screen-lg px-4 md:px-10 flex items-center justify-between">
                    <Link to={"/"} className="flex items-center gap-4 py-4">
                        <img src={logo} className="max-w-[40px] w-full rounded-full" alt="img" />
                        <div className="font-semibold text-center lg:text-xl text-green-400 dark:text-pink-700">
                            SoundOfMeme
                        </div>
                    </Link>
                    <Link to="/" className="text-slate-300 dark:text-slate-700 font-medium hover:text-green-400 dark:hover:text-pink-700">
                        Home
                    </Link>
                </div>
            </div>
            <div className={`max-w-screen-lg mx-auto px-4 md:px-10 py-20 ${playing ? 'mb-24 sm:mb-12' : ''}`}>
                <div className="flex border-b border-slate-700 dark:border-pink-400 mb-6">
                    <button className={`py-2 px-4 font-medium ${activeTab === 'bulkEmail' ?  'text-green-400 dark:text-pink-700 border-b-2 border-green-400 dark:border-pink-700' : 'text-slate-400 dark:text-slate-600 hover:text-green-400 dark:hover:text-pink-700'}`} onClick={() => setActiveTab('bulkEmail')}>Bulk Email</button>
                    <button className={`py-2 px-4 font-medium ${activeTab === 'reviews' ? 'text-green-400 dark:text-pink-700 border-b-2 border-green-400 dark:border-pink-700' : 'text-slate-400 dark:text-slate-600 hover:text-green-400 dark:hover:text-pink-700'}`} onClick={() => setActiveTab('reviews')}>Reviews</button>
                </div>
                {activeTab === 'bulkEmail' && (
                    <>
                        <h1 className="font-potta text-4xl text-green-400 dark:text-pink-700">Bulk Email URL Generator</h1>
                        <div className="mt-8">
                            <label htmlFor="emails" className="block mb-2 font-medium">
                                Enter Email Addresses (comma separated)
                            </label>
                            <div className="flex flex-col md:flex-row gap-4">
                                <textarea id="emails" value={emails} onChange={(e) => setEmails(e.target.value)} placeholder="email1@example.com, email2@example.com" className="flex-1 p-2 rounded bg-slate-800 dark:bg-pink-100 text-slate-200 dark:text-slate-700 border border-slate-700 dark:border-pink-400" rows={3} />
                                <button onClick={generateUrls} disabled={loading} className="px-6 py-2 bg-green-500 dark:bg-pink-500 text-white rounded hover:bg-green-600 dark:hover:bg-pink-600 disabled:opacity-50 md:self-end">
                                    {loading ? 'Generating...' : 'Generate URLs'}
                                </button>
                            </div>
                            {error && <p className="mt-2 text-red-400">{error}</p>}
                        </div>
                        <div className="mt-8 space-y-4">
                            <div>
                                <label htmlFor="emailFrom" className="block mb-2 font-medium">
                                    From Email
                                </label>
                                <input id="emailFrom" value={emailFrom} onChange={(e) => setEmailFrom(e.target.value)} className="w-full p-2 rounded bg-slate-800 dark:bg-pink-100 text-slate-200 dark:text-slate-700 border border-slate-700 dark:border-pink-400" />
                            </div>
                            <div>
                                <label htmlFor="emailSubject" className="block mb-2 font-medium">
                                    Email Subject
                                </label>
                                <input id="emailSubject" value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} className="w-full p-2 rounded bg-slate-800 dark:bg-pink-100 text-slate-200 dark:text-slate-700 border border-slate-700 dark:border-pink-400" />
                            </div>
                            <div>
                                <label htmlFor="emailMessage" className="block mb-2 font-medium">
                                    Email Message
                                </label>
                                <textarea id="emailMessage" value={emailMessage} onChange={(e) => setEmailMessage(e.target.value)} className="w-full p-2 rounded bg-slate-800 dark:bg-pink-100 text-slate-200 dark:text-slate-700 border border-slate-700 dark:border-pink-400" rows={3} />
                            </div>
                        </div>
                        {urls.length > 0 && (
                            <div className="mt-8">
                                <h2 className="text-2xl font-potta text-green-400 dark:text-pink-700 mb-4">Generated URLs</h2>
                                <ul className="space-y-4">
                                    {urls.map((item, index) => (
                                        <li key={index} className="bg-slate-800 dark:bg-pink-100 p-4 rounded flex flex-col gap-2">
                                            <div className="flex items-center">
                                                <span className="font-medium mr-2">{index + 1}.</span>
                                                <span className="font-medium text-green-300 dark:text-pink-600">{item.email}</span>
                                            </div>
                                            <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 pl-6">
                                                <div className="flex-1 break-all">
                                                    <a href={item.url} target="_blank" rel="noopener noreferrer" className="text-green-400 dark:text-pink-700 hover:underline">
                                                        {item.url}
                                                    </a>
                                                </div>
                                                <div className="flex gap-2">
                                                    <button onClick={() => copyToClipboard(item.url)} className="px-4 py-1 bg-slate-700 dark:bg-pink-300 rounded hover:bg-slate-600 dark:hover:bg-pink-400">Copy URL</button>
                                                    <a href={item.gmailLink} target="_blank" rel="noopener noreferrer" className="px-4 py-1 bg-green-600 dark:bg-pink-500 text-white rounded hover:bg-green-700 dark:hover:bg-pink-600 inline-block text-center">Gmail</a>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </>
                )}
                {activeTab === 'reviews' && (
                    <>
                        <h1 className="font-potta text-4xl text-green-400 dark:text-pink-700 mb-6">Review Management</h1>
                        
                        <div className="flex flex-row gap-4 items-center mb-6">
                            <label htmlFor="status-filter" className="block mb-2 font-medium">
                                Filter by Status:
                            </label>
                            <select
                                id="status-filter"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                                className="p-2 rounded bg-slate-800 dark:bg-pink-100 text-slate-200 dark:text-slate-700 border border-slate-700 dark:border-pink-400"
                            >
                                <option value="pending">Pending</option>
                                <option value="in_progress">In Progress</option>
                                <option value="resolved">Resolved</option>
                                <option value="dismissed">Dismissed</option>
                            </select>
                        </div>
                        
                        {reviewsLoading ? (
                            <div className="flex justify-center py-8">
                                <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-green-400 dark:border-pink-700"></div>
                            </div>
                        ) : reviewsError ? (
                            <div className="text-red-400 p-4 bg-slate-800 dark:bg-pink-100 rounded">
                                {reviewsError}
                            </div>
                        ) : (
                            <>
                                <div className="mt-6">
                                    <h3 className="text-xl font-medium mb-4">Review Details</h3>
                                    {reviews.length > 0 && (
                                        <div className="space-y-4">
                                            {reviews.map(review => (
                                                <div key={review.id} className="p-4 bg-slate-900 dark:bg-slate-800 rounded text-slate-300 dark:text-slate-200 border border-slate-700">
                                                    <div className="flex flex-col sm:flex-row sm:justify-between mb-2">
                                                        <div className="font-medium text-green-400 dark:text-pink-400">#{review.id} - {review.name}</div>
                                                        <div className="text-sm text-slate-400">{formatDate(review.created_at)}</div>
                                                    </div>
                                                    
                                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-1 mb-3 text-sm">
                                                        <div className="flex flex-row items-center">
                                                            <span className="text-slate-500 mr-2">Email:</span>
                                                            <span className="text-slate-300">{review.email}</span>
                                                        </div>
                                                        <div className="flex flex-row items-center">
                                                            <span className="text-slate-500 mr-2">Status:</span>
                                                            <span className={`px-2 py-0.5 rounded text-white ${
                                                                review.status === 'pending' ? 'bg-yellow-600' : 
                                                                review.status === 'in_progress' ? 'bg-blue-600' :
                                                                review.status === 'resolved' ? 'bg-green-600' : 'bg-red-600'
                                                            }`}>
                                                                {review.status.charAt(0).toUpperCase() + review.status.slice(1)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-1 mb-3 text-sm">
                                                        <div className="flex flex-row items-center">
                                                            <span className="text-slate-500 mr-2">Rating:</span>
                                                            <div className="flex">
                                                                {[...Array(5)].map((_, i) => (
                                                                    <span key={i} className={`text-lg ${i < review.rating ? 'text-yellow-400' : 'text-slate-600'}`}>
                                                                        ★
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <div className="flex flex-row items-center">
                                                            <span className="text-slate-500 mr-2">Type:</span>
                                                            <span className="text-slate-300 capitalize">{review.review_type.replace(/_/g, ' ')}</span>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="mt-3 border-t border-slate-700 pt-2">
                                                        <div className="font-medium text-slate-300 mb-1">Review:</div>
                                                        <p className="text-slate-400">{review.description}</p>
                                                    </div>
                                                    
                                                    {review.admin_notes && (
                                                        <div className="mt-2 pt-2 border-t border-slate-700">
                                                            <div className="font-medium text-slate-300 mb-1">Admin Notes:</div>
                                                            <p className="text-slate-400">{review.admin_notes}</p>
                                                        </div>
                                                    )}
                                                    
                                                    {review.updated_at && (
                                                        <div className="mt-2 text-xs text-slate-500">
                                                            Updated: {formatDate(review.updated_at)}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {pagination.total_pages > 1 && renderPagination()}
                            </>
                        )}
                    </>
                )}
            </div>
            <BottomBar />
        </div>
    )
}

export default BulkEmail